import { render, staticRenderFns } from "./SurgeryCard.vue?vue&type=template&id=61691600&scoped=true"
import script from "./SurgeryCard.vue?vue&type=script&lang=js"
export * from "./SurgeryCard.vue?vue&type=script&lang=js"
import style0 from "./SurgeryCard.vue?vue&type=style&index=0&id=61691600&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61691600",
  null
  
)

export default component.exports